import { USER_REDUCER_NAME } from './Constants';

const useIsLoggedIn = ({ [USER_REDUCER_NAME]: { isLoggedIn } }) => isLoggedIn;

const useSub = ({
  [USER_REDUCER_NAME]: {
    user: { sub },
  },
}) => sub;

const useUser = ({ [USER_REDUCER_NAME]: { user } }) => user;

export { useIsLoggedIn, useSub, useUser };
